import axios from 'axios';
import { Api } from './Api';
import subject from '../helper/Rxjs';
import { useNavigate } from 'react-router-dom';

const locationUrl =
	'https://maps.googleapis.com/maps/api/place/autocomplete/json';
const geocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json';

const locationKey = process.env.REACT_APP_LOCATION_KEY2;
const host = process.env.REACT_APP_HOST;
const gEnv = 'qa';

const reqApi = Api(host, gEnv);

axios.interceptors.response.use(
	function (res) {
		if (res?.status === 404) {
			subject.next(2);
		}
		if (res?.status === 403 || res?.status === 401) {
			subject.next(1);
			localStorage.clear();
			window.location.assign('/');
			return;
		}

		return res;
	},
	err => {
		if (err?.response?.status === 404) {
			subject.next(2);
		}
		if (err?.response?.status === 403 || err?.response?.status === 401) {
			subject.next(1);
			localStorage.clear();
			window.location.assign('/');
			return;
		}

		return Promise.reject(err);
	}
);

export const ReqGet = (endpoint, token = null, props = {}) => {
	return httpReq('GET', endpoint, token, props);
};

export const ReqPost = (endpoint, payload, token = null) => {
	return httpReq('POST', endpoint, token, { data: payload });
};

export const ReqPatch = (endpoint, payload, token = null) => {
	return httpReq('PATCH', endpoint, token, { data: payload });
};

export const httpReq = (method, endpoint, token = null, props = {}) => {
	if (!token && endpoint !== 'login') {
		const profile = JSON.parse(localStorage.getItem('cogen_user_profile'));
		token = profile ? profile.accessToken : '';
	}
	const isFormData = props?.data instanceof FormData ? true : false
	const params = {
		method: method,
		baseURL: reqApi,
		url: endpoint,
		headers: {
			Accept: 'application/json',
			// 'Content-Type': 'application/json',
			'Content-Type':  isFormData ? 'multipart/form-data' : 'application/json',
			env: gEnv,
		},
	};
	Object.assign(params, props);
	if (token) {
		params.headers.Authorization = `Bearer ${token}`;
	}

	return axios(params);
};

export const getLocation = searchedLocation => {
	const endpoint = `${locationUrl}?key=${locationKey}&input=${searchedLocation}`;
	return httpReq('GET', endpoint);
};

export const getLocationDetailByPlaceId = (placeId = '') => {
	const endpoint = `${geocodeUrl}?key=${locationKey}&place_id=${placeId}`;
	return httpReq('GET', endpoint);
};

export const globalEnv = gEnv;
